import React from "react";
import { FaLightbulb, FaRocket } from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";
import { TbBrandReactNative } from "react-icons/tb";

const ProcessSection = () => {
    return (
        <>
            <section className="process-section">

                {/* Animated Blur */}
                <div className="process-blur process-blur-1"></div>
                <div className="process-blur process-blur-2"></div>

                <div className="process-container">

                    {/* Heading */}
                    <div className="process-heading">

                        <span className="process-badge">
                            PROCESS
                        </span>

                        <h2 style={{ textAlign: "center", }}>
                            Turning App Ideas Into<br />
                            <span> Powerful Digital Products.</span>
                        </h2>

                        <p style={{ textAlign: "center", }}>
                            From strategy and UI/UX design to development
                            and App Store launch — we build mobile apps
                            users genuinely love.
                        </p>

                    </div>

                    {/* Cards */}
                    <div className="process-grid">
                        {/* Card */}
                        <div className="process-card">

                            <div className="process-line"></div>

                            <div className="process-number">01</div>

                            <div className="process-icon-wrap">
                                <div className="process-icon">
                                    <FaLightbulb />
                                </div>
                            </div>

                            <h3>Idea & Strategy</h3>

                            <p>
                                We analyze your app concept, business goals
                                and target audience before development begins.
                            </p>

                            <div className="process-tags">
                                <span>Research</span>
                                <span>Planning</span>
                                <span>Roadmap</span>
                            </div>

                        </div>

                        {/* Card */}
                        <div className="process-card">

                            <div className="process-line"></div>

                            <div className="process-number">02</div>

                            <div className="process-icon-wrap">
                                <div className="process-icon">
                                    <MdDesignServices />
                                </div>
                            </div>

                            <h3>UI/UX Design</h3>

                            <p>
                                Beautiful mobile-first designs focused on
                                smooth interactions and user engagement.
                            </p>

                            <div className="process-tags">
                                <span>Wireframes</span>
                                <span>Prototype</span>
                                <span>Experience</span>
                            </div>

                        </div>

                        {/* Card */}
                        <div className="process-card">

                            <div className="process-line"></div>

                            <div className="process-number">03</div>

                            <div className="process-icon-wrap">
                                <div className="process-icon">
                                    <TbBrandReactNative />
                                </div>
                            </div>

                            <h3>App Development</h3>

                            <p>
                                Building scalable iOS, Android and
                                cross-platform applications with modern stacks.
                            </p>

                            <div className="process-tags">
                                <span>React Native</span>
                                <span>Flutter</span>
                                <span>Backend</span>
                            </div>

                        </div>

                        {/* Card */}
                        <div className="process-card">

                            <div className="process-line"></div>

                            <div className="process-number">04</div>

                            <div className="process-icon-wrap">
                                <div className="process-icon">
                                    <FaRocket />
                                </div>
                            </div>

                            <h3>Launch & Scale</h3>

                            <p>
                                We deploy your app to stores,
                                optimize performance and help scale growth.
                            </p>

                            <div className="process-tags">
                                <span>Deployment</span>
                                <span>ASO</span>
                                <span>Growth</span>
                            </div>

                        </div>
                    </div>

                </div>
                <style>
                    {`.process-icon{
    width:70px;
    height:70px;
    border-radius:20px;
    display:flex;
    align-items:center;
    justify-content:center;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    color:#fff;
    font-size:30px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:all .4s ease;
}

.process-card:hover .process-icon{
    transform:translateY(-8px) rotate(-8deg);
    box-shadow:
        0 25px 50px rgba(232,33,42,.35);
}`}
                </style>
            </section>
        </>
    );
};

export default ProcessSection;